/*jshint esversion: 6 */


import { library } from '@fortawesome/fontawesome-svg-core';
import { 
    faCheck, 
    faClock, 
    faEye, 
    faEyeSlash, 
    faCircleExclamation, 
    faExclamation, 
    faMagnifyingGlassPlus, 
    faMagnifyingGlassMinus, 
    faPrint ,
    faSquare as faSquareSolid,
    faSquareFull as faSquareSolidFull,
    faXmark,
    faArrowUpFromBracket,
    faPlus,
    faMinus

} from '@fortawesome/free-solid-svg-icons';
import {
    faSquare,
    faSquareCheck,
    faSquareFull,
    faTrashCan,
    faCircle,
} from '@fortawesome/free-regular-svg-icons';
library.add(
    faArrowUpFromBracket,
    faCheck, 
    faClock, 
    faEye, 
    faEyeSlash, 
    faCircleExclamation, 
    faExclamation, 
    faMagnifyingGlassPlus, 
    faMagnifyingGlassMinus, 
    faPrint, 
    faSquare,
    faSquareSolid,
    faSquareCheck,
    faSquareFull,
    faSquareSolidFull,
    faTrashCan,
    faXmark,
    faPlus,
    faCircle,
    faMinus
);
